export default "__VITE_ASSET__DD2lD6xI__"